var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cashflowTabsEnabled)?_c('keep-alive',{attrs:{"include":"CashflowApp,PlanAheadPage"}},[_c('router-view',{staticClass:"view"})],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }